module.exports = __webpack_public_path__ + "assets/img/beed0c05212013bdd9b73863e720d9ef.svg";